/** Lógica pura del índice CAC: período mensual ("AAAA-MM", como devuelve <input type="month">) y valor como texto. */
import { hoyISO } from "./format";
import { montoAInput, parseMonto } from "./gastos";
import type { IndiceCac } from "./api";

const MESES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
const PATRON = /^(\d{4})-(0[1-9]|1[0-2])$/;
const valorIndice = new Intl.NumberFormat("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export interface FormIndice {
  periodo: string;
  valor: string;
}

export type ErroresIndice = Partial<Record<keyof FormIndice, string>>;

export function periodoDe(fechaISO: string): string {
  return fechaISO.slice(0, 7);
}

/** "2026-09" → "sep 2026". Devuelve el texto tal cual si no es un período válido. */
export function etiquetaPeriodo(periodo: string): string {
  const m = PATRON.exec(periodo);
  if (!m) return periodo;
  return `${MESES[Number(m[2]) - 1]} ${m[1]}`;
}

/** "1500.00" → "1.500,00": el índice siempre con dos decimales (formatNumero los recorta). */
export function formatIndice(valor: string): string {
  return valorIndice.format(Number(valor));
}

function mesAnterior(periodo: string): string {
  const anio = Number(periodo.slice(0, 4));
  const mes = Number(periodo.slice(5, 7));
  return mes === 1 ? `${anio - 1}-12` : `${anio}-${String(mes - 1).padStart(2, "0")}`;
}

export function formIndice(i?: IndiceCac, hoy = hoyISO()): FormIndice {
  if (!i) return { periodo: mesAnterior(periodoDe(hoy)), valor: "" };
  return { periodo: i.periodo, valor: montoAInput(i.valor) };
}

export function validarIndice(f: FormIndice): ErroresIndice {
  const e: ErroresIndice = {};
  if (!PATRON.test(f.periodo)) e.periodo = "Elegí el mes";
  if (parseMonto(f.valor) === null) e.valor = "Ingresá un valor mayor a cero";
  return e;
}

export function aPayloadIndice(f: FormIndice): { valor: string } {
  return { valor: parseMonto(f.valor) ?? "0" };
}
